// ===========================================================================
// CDCI v2 — constantes del módulo.
//
// El v2 existe para REFACTORIZAR LA TRANSCRIPCIÓN (AI Scribe) sin tocar el
// CDCI productivo: re-exporta TODAS las constantes del v1 y pisa solo las que
// distinguen al módulo (path y nombre). Las páginas duplicadas importan
// `../common/constants` y, gracias a esto, navegan dentro de /cdci-v2 sin
// cambiar ninguna otra línea.
//
// Regla de ESM: un export local con el mismo nombre PISA al del `export *` —
// por eso CDCI_BASE_PATH y CDCI_FULL_NAME quedan redefinidos sin conflicto.
// ===========================================================================
export * from "../../cdci/common/constants";

/**
 * Gate del módulo: gobierna las rutas (index.js exporta [] si está apagado) y
 * el ítem del sidebar. 2026-11-04: pasa a PRODUCCIÓN (true) — el v2 convive
 * con el CDCI v1 con el mismo acceso RBAC (módulo `cdci`, 37) y los mismos
 * permisos de inserción por rol (noteInsertService del v1). El flag queda
 * como kill switch: volver a `process.env.NODE_ENV === "development"` lo
 * retira de producción sin tocar nada más.
 */
export const CDCI_V2_ENABLED = true;

export const CDCI_BASE_PATH = "/cdci-v2";

// El sufijo v2 se muestra a propósito: en dev conviven los dos módulos y el
// header tiene que decir en cuál se está parado.
export const CDCI_FULL_NAME = "Clinical Documentation & Charge Intelligence (v2)";
